export default __webpack_public_path__ + "static/media/eduact-card-icon.9d26ac83.svg";